import { LANDING_AMPLITUDE_EVENTS, LOCAL_STORAGE_KEYS } from '@/constants';
import howWork from '@/public/images/avi-to-mp4-converter/howItWorks.webp';
import whyLift from '@/public/images/avi-to-mp4-converter/whyLift.webp';
import { type LandingConfigItem } from '../../types';
import { exploreConfig } from './exploreConfig';
import { tryLiftConfig } from './tryLiftConfig';

export const landingAviToMp4ConverterConfig: LandingConfigItem = {
	id: 'AviToMp4Converter',
	translationLocale: 'avi-to-mp4-converter',
	withDropZone: true,
	hero: {
		type: 'withVideoUpload',
		title: 'heroData_title',
		description: 'heroData_subtitle',
		buttonText: 'heroData_buttonText',
		data: {
			dropzoneTitle: 'heroData_dropzoneTitle',
			format: 'sharedLandingData:format',
			size: 'sharedLandingData:size',
		},
	},
	howItWork: {
		title: 'howItWorkData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				icon: '🎬',
				title: 'howItWorkData_title1',
				subtitle: 'howItWorkData_subtitle1',
			},
			{
				icon: '🎞️',
				title: 'howItWorkData_title2',
				subtitle: 'howItWorkData_subtitle2',
			},
			{
				icon: '✨',
				title: 'howItWorkData_title3',
				subtitle: 'howItWorkData_subtitle3',
			},
			{
				icon: '🤘',
				title: 'howItWorkData_title4',
				subtitle: 'howItWorkData_subtitle4',
			},
		],
		images: [
			{
				image: howWork,
				title: 'howItWorkData_imageTitle',
				alt: 'howItWorkData_imageAlt',
			},
		],
	},
	whyLift: {
		title: 'whyUseData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				icon: '✅',
				title: 'whyUseData_title1',
				subtitle: 'whyUseData_subtitle1',
			},
			{
				icon: '✅',
				title: 'whyUseData_title2',
				subtitle: 'whyUseData_subtitle2',
			},
			{
				icon: '✅',
				title: 'whyUseData_title3',
				subtitle: 'whyUseData_subtitle3',
			},
			{
				icon: '✅',
				title: 'whyUseData_title4',
				subtitle: 'whyUseData_subtitle4',
			},
		],
		images: [
			{
				image: whyLift,
				title: 'whyUseData_imageTitle',
				alt: 'whyUseData_imageAlt',
			},
		],
	},
	faq: {
		title: 'faqData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{ title: 'faqData_title1', subtitle: 'faqData_subtitle1' },
			{ title: 'faqData_title2', subtitle: 'faqData_subtitle2' },
			{ title: 'faqData_title3', subtitle: 'faqData_subtitle3' },
			{ title: 'faqData_title4', subtitle: 'faqData_subtitle4' },
			{
				title: 'faqData_title5',
				subtitle: 'faqData_subtitle5',
				optional: true,
			},
		],
	},
	explore: { ...exploreConfig },
	tryLift: { ...tryLiftConfig },
	analytics: {
		scrolledPercentName:
			LOCAL_STORAGE_KEYS.AVI_TO_MP4_CONVERTER_SCROLLED_POINTS,
		eventPropertyType: LANDING_AMPLITUDE_EVENTS.AVI_TO_MP4_CONVERTER,
		galleryContext: LANDING_AMPLITUDE_EVENTS.AVI_TO_MP4_CONVERTER_LANDING,
	},
};
